<template>
<div class="container">
     <van-overlay :show="showTv" @click="hideTv" >
        <div id="id_test_video" style="width:100%; height:auto;margin-top:140px;"></div>
     </van-overlay>
</div>
</template>
<script>
    export default {
        props: {
            playUrl: {
                type: String,
                default: ''
            },
            postUrl: {
                type: String,
                default: ''
            }
        },
        watch: {
            playUrl: {
                handler (newValue, oldValue) {
                    // debugger
                    this.initPlayer();
                },
                deep: true
            }
        },
        data () {
            return {
                player: null,
                showTv: false
            }
        },
        mounted () {

            // this.$nextTick(() => {
            //     this.initPlayer();
            // }, 1000)
        },
        created () {

        },
        methods: {
            hideTv () {
                this.showTv = false;
                if (this.player) {
                    this.player.destroy();
                    this.player = null;
                }
            },
            showPlayer () {
                this.showTv = true;
                // debugger
                if (this.playUrl) {
                    this.initPlayer()
                };
            },

            initPlayer () {
                if (!this.player) {
                    this.player = new TcPlayer('id_test_video', {
                        'mp4': this.playUrl, // 请替换成实际可用的播放地址
                        'autoplay': false, // iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                        'poster': this.postUrl,
                        'width': '480', // 视频的显示宽度，请尽量使用视频分辨率宽度
                        'height': '320', // 视频的显示高度，请尽量使用视频分辨率高度
                        'controls': 'system'
                    });
                } else {
                    this.player.load(this.playUrl);
                }
            }
        },
        destroyed () {

        }
    }
</script>
<style lang="less" scoped>
.container{
    width:100%;
    height:100%;
    padding-top:128px;
    .id_test_video{
        // position: absolute;
        // left:0;
        // top:128px;
        // z-index: 2;
        // margin-top:200px;
        .vcp-player{
          top:128px;
        }
    }
}
</style>
